import { render, staticRenderFns } from "./save-to-database.vue?vue&type=template&id=1e5df90f&"
import script from "./save-to-database.vue?vue&type=script&lang=js&"
export * from "./save-to-database.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports